<ng-container *ngIf="user()">
	<ng-container *ngIf="('showAllHistory' | userPermission | async)">
		<div *ngIf="user().prerequisits.length === 0">
			<a routerLink="/release-notes.do?doShowReleaseNotes=1">
				{{"frame.footer.history" | msgKey}}
			</a>
		</div>
	</ng-container>
</ng-container>